function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Observer = /*#__PURE__*/function () {
  function Observer(_ref) {
    var _this = this;

    var name = _ref.name,
        _ref$events = _ref.events,
        events = _ref$events === void 0 ? [] : _ref$events,
        _ref$allowDynamicEven = _ref.allowDynamicEvents,
        allowDynamicEvents = _ref$allowDynamicEven === void 0 ? false : _ref$allowDynamicEven;

    _classCallCheck(this, Observer);

    _defineProperty(this, "on", function (eventType, callback) {
      if (typeof callback !== 'function') throw new Error("Callback not a function: Cannot set callback for ".concat(_this.name, " event ").concat(eventType));
      var callbacks = _this._callbacks[eventType];

      if (!(callbacks instanceof Array)) {
        if (!_this._allowDynamicEvents) {
          throw new Error("Event type ".concat(eventType, " is not supported for ").concat(_this.name));
        }

        _this._callbacks[eventType] = [];
      }

      _this._callbacks[eventType].push(callback);

      return function () {
        _this._callbacks[eventType] = _this._callbacks[eventType].filter(function (cb) {
          return cb !== callback;
        });
      };
    });

    this.name = name;
    this._allowDynamicEvents = allowDynamicEvents;
    this._callbacks = events.reduce(function (result, eventName) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, eventName, []));
    }, {});
  }

  _createClass(Observer, [{
    key: "emit",
    value: function emit(type, data) {
      var cbs = this._callbacks[type] || [];
      cbs.forEach(function (cb) {
        return cb(data);
      });
    }
  }, {
    key: "off",
    value: function off() {
      var _this2 = this;

      Object.keys(this._callbacks).forEach(function (eventName) {
        _this2._callbacks[eventName] = [];
      });
    }
  }]);

  return Observer;
}();

export default Observer;